import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const FlIntegrationService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getFlRenewalBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/fldmv/search${queryString}`, {
      headers,
    });
  };

  service.getFlRenewalBySearchCriteria = getFlRenewalBySearchCriteria;

  service.getRenewalByTransactionId = (transactionId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/fldmv/renewal/${transactionId}`, { headers, });
  };

  service.retryRegistration = (txnId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/fldmv/retry`, { txnId, }, { headers, });
  };

  return service;
})();

export default FlIntegrationService;
